(function($R) {
  $R.options = {
    linkNewTab: true,
    plugins: ["fullscreen"],

    imageResizable: true,
    imagePosition: true
  };

  $R(".imgupload", {
    imageUpload: "/image-upload"
  });
})(Redactor);
